import { Dispatch } from "redux";
import { createSlice } from "@reduxjs/toolkit";
import * as serverRequest from "../../_apis/WalletCrud";

export interface WALLET_INITIAL_STATE {
  error: boolean;
  isLoading: boolean;
  walletsPayload: string[];
  selectedWallet: any;
}

const initialState: WALLET_INITIAL_STATE = {
  error: false,
  isLoading: false,
  walletsPayload: [],
  selectedWallet: null,
};

const slice = createSlice({
  name: "wallets",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    setWallets(state, action) {
      state.isLoading = false;
      state.walletsPayload = action.payload.walletsPayload;
    },
    setSelectedWallet(state, action) {
      state.selectedWallet = action.payload.selectedWallet;
    },
  },
});

export default slice.reducer;

export const getWalletListByNetwork =
  (networkId: string) => (dispatch: Dispatch) => {
    dispatch(slice.actions.startLoading());

    serverRequest
      .getWalletsByNetwork(networkId)
      .then((res) => {
        dispatch(
          slice.actions.setWallets({
            walletsPayload: res.data.body.walletByNetworks,
          })
        );
      })
      .catch((e) => {
        if (e.response) {
          dispatch(slice.actions.hasError(e.response?.data?.status?.message));
        } else {
          dispatch(
            slice.actions.hasError("Something went wrong. Try again later!")
          );
        }
      });
  };

export const getWalletList = () => (dispatch: Dispatch) => {
  dispatch(slice.actions.startLoading());
  serverRequest
    .getWallets()
    .then((res) => {
      dispatch(
        slice.actions.setWallets({
          walletsPayload: res.data.body.walletByNetworks,
        })
      );
    })
    .catch((e) => {
      if (e.response) {
        dispatch(slice.actions.hasError(e.response?.data?.status?.message));
      } else {
        dispatch(
          slice.actions.hasError("Something went wrong. Try again later!")
        );
      }
    });
};

export const setSelectedWallet =
  (selectedWallet: any) => (dispatch: Dispatch) => {
    dispatch(slice.actions.setSelectedWallet({ selectedWallet }));
  };
